/*
 * Public API Surface of inova-core
 */

export * from './tutorials.service'


